/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext, useContext } from 'react';
import SendBird from 'sendbird';

export interface AuthContextValue {
  currentUser: SendBird.User | null;
  updateCurrentUserState: () => void;
  initializeCurrentUser: () => void;
  isInitializingUser: boolean;
}

export const AuthContext = createContext<AuthContextValue>({} as any);

export const useAuthContext = () => useContext(AuthContext);
